import { $wallet, walletChange } from "../wallet";
import {
  StoreValue,
  attach,
  createEffect,
  createEvent,
  createStore,
  forward,
  sample,
} from "effector";
import {
  createSaleFx,
  purchaseAhFx,
  purchaseCmFx,
  purchaseFpFx,
} from "../sales";

import { $connection } from "state/connection";
import { Account } from "@metaplex-foundation/mpl-core";
import { endSaleFx } from "../sales/AH/endSaleFx";
import { interval } from "patronum";
import { lamportsToSol } from "utils/lamportsToSol";
import { mintArweaveFx } from "../artworks";
import { submitStoreFx } from "../store";
import { withdrawFx } from "../sales/AH/withdrawFx";

export const startBalancePolling = createEvent();
export const stopBalancePolling = createEvent();

const { tick } = interval({
  timeout: 5_000,
  start: startBalancePolling,
  stop: stopBalancePolling,
});

export const updateWalletBalanceFx = attach({
  effect: createEffect(
    async ({
      wallet,
      connection,
    }: {
      wallet: StoreValue<typeof $wallet>;
      connection: StoreValue<typeof $connection>;
    }) => {
      if (!wallet) {
        throw new Error("empty wallet");
      }

      const account = await Account.load(connection, wallet.publicKey);
      return lamportsToSol(account.info?.lamports || 0);
    }
  ),
  source: {
    wallet: $wallet,
    connection: $connection,
  },
});

export const $walletBalance = createStore<number>(0);

forward({
  from: [walletChange, $connection],
  to: updateWalletBalanceFx,
});

forward({ from: updateWalletBalanceFx.doneData, to: $walletBalance });

forward({ from: tick, to: updateWalletBalanceFx });

sample({
  clock: [
    submitStoreFx.finally,
    mintArweaveFx.finally,
    createSaleFx.finally,
    purchaseAhFx.finally,
    purchaseCmFx.finally,
    purchaseFpFx.finally,
    withdrawFx.finally,
    endSaleFx.finally,
  ],
  target: updateWalletBalanceFx,
});
